import { AsyncStore } from "~/store/async-store"
import { initial } from "~/store/async-store.utils"
import { Instrument } from "./instrument.model"

type Err = string
type Ok = {
  instruments: Instrument[]
}

export class InstrumentsStore extends AsyncStore<Err, Ok> {
  constructor() {
    super("InstrumentsStore", initial)
  }
}
